// Source: app/scripts/controllers/lot-details.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('LotDetailsController', [
    '$scope',
    '$filter',
    '$routeParams',
    '$sce',
    '$modal',
    'toaster',
    'Lot',
    'Auction',
    'AuctionParticipationRequest',
    function ($scope, $filter, $routeParams, $sce, $modal, toaster, Lot, Auction, AuctionParticipationRequest) {

        $scope.lotId = $routeParams.lotId;
        $scope.auctionId = $routeParams.auctionId;
        $scope.auction = Auction.get({
            id: $scope.auctionId
        });

        function load() {

            Lot.getDto({
                lotId: $scope.lotId,
                auctionId: $scope.auctionId
            }, function (data) {
                $scope.lotDto = data;
            });
        }
        
        load();

//    function load() {
//      Lot.getProducts({
//        id: $scope.lotId
//      }, function (data) {
//        $scope.lots = {};
//        angular.forEach(data, function (prod) {
//          if (!$scope.lots[prod.lot.id]) {
//            prod.lot.request = {};
//            AuctionParticipationRequest.getLotRequest({
//              id: prod.lot.id
//            }, function (data) {
//              if (data && data.lot) {
//                $scope.lots[data.lot.id].request = data;
//              } else {
//                $scope.lots[prod.lot.id].request = null;
//              }
//            })
//          }
//          $scope.lots[prod.lot.id] = $scope.lots[prod.lot.id] || prod.lot;
//          $scope.lots[prod.lot.id].products = $scope.lots[prod.lot.id].products || [];
//          $scope.lots[prod.lot.id].products.push(prod);
//        });
//      });
//    }
//
//
//    load();

        $scope.modalSend = $modal({
            scope: $scope,
            template: 'forms/modals/send_lot_request.html',
            show: false
        });

        $scope.registerForAuction = function (lotDto) {
            $scope.requestEntity = {
                lot: {
                    id: lotDto.lot.id
                },
                auction: lotDto.lot.auction
            };

            Lot.getLicensesTypes({
                id: lotDto.lot.id
            }, function (data) {
                lotDto.licenses = data;
            });
            $scope.req = {
                lotDto: lotDto
            };
            $scope.modalSend.show();
        };


        $scope.sendLotRequest = function () {
            AuctionParticipationRequest.sendRequest($scope.requestEntity, function () {
                delete $scope.requestEntity;
                $scope.modalSend.hide();
                load();
                toaster.pop('success', $filter('translate')('generic.success'),
                        $filter('translate')("eauction.request_sent"));
            }, function () {
                load();
            });
        };

    }]);
